import { getTypographyStyles } from "./utils";
export const ThemedText = {
    variants: {
        'body.2xl': getTypographyStyles('body.2xl'),
        'body.xl.default': getTypographyStyles('body.xl.default'),
        'body.xl.underlined': getTypographyStyles('body.xl.underlined'),
        'body.l.default': getTypographyStyles('body.l.default'),
        'body.l.underlined': getTypographyStyles('body.l.underlined'),
        'body.m.default': getTypographyStyles('body.m.default'),
        'body.m.underlined': getTypographyStyles('body.m.underlined'),
        'body.s.default': getTypographyStyles('body.s.default'),
        'body.s.underlined': getTypographyStyles('body.s.underlined'),
        'body.xs.default': getTypographyStyles('body.xs.default'),
        'body.xs.underlined': getTypographyStyles('body.xs.underlined'),
        'body.2xs.default': getTypographyStyles('body.2xs.default'),
        'body.2xs.underlined': getTypographyStyles('body.2xs.underlined')
    },
    defaultProps: {
        variants: 'body.s.default'
    }
};

//# sourceMappingURL=Text.js.map